const accessRoute = {
  RESET_PASSWORD: {
    path: "/admin/reset-password",
  },
};
export default accessRoute;
